const config = {
  WS_BASE_URL: "https://api.topdevacademy.com/api",
  Data_URL: "https://app.topdevacademy.com/",
  File_URL : "https://app.topdevacademy.com",
  DOMAIN_NAME: 'https://app.topdevacademy.com',
  Private_Policy_URL: "https://aaaaaa.com/uploads/aaaaaa_Politique.pdf",
  DEMO: true,
  Environment: "Prod",  
}

export default config;
